import React from "react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Target, X } from "lucide-react";

export function DashboardToolbar({
  crashRiskFilter,
  setCrashRiskFilter,
  searchQuery,
  setSearchQuery,
  categoryFilter,
  setCategoryFilter,
  filteredSymbolsCount,
  totalSymbolsCount,
}) {
  return (
    <>
      <div className="dashboard-card p-4">
        <div className="flex items-center gap-2 overflow-x-auto pb-2 sm:pb-0">
          {[
            { label: 'BUY', text: '0–20 BUY', cls: 'bg-emerald-100 text-emerald-700' },
            { label: 'HOLD', text: '21–40 HOLD', cls: 'bg-yellow-100 text-yellow-800' },
            { label: 'PREPARE SELL', text: '41–60 PREPARE SELL', cls: 'bg-orange-100 text-orange-800' },
            { label: 'SELL', text: '61–80 SELL', cls: 'bg-red-100 text-red-700' },
            { label: 'CRASH ZONE', text: '81–100 CRASH ZONE', cls: 'bg-red-600 text-white' },
          ].map((badge) => (
            <button
              key={badge.label}
              onClick={() => setCrashRiskFilter(crashRiskFilter === badge.label ? 'All' : badge.label)}
              className={`inline-flex items-center justify-center h-7 px-2 rounded-md text-xs font-medium leading-none whitespace-nowrap transition-colors ${badge.cls} ${crashRiskFilter === badge.label ? 'ring-2 ring-slate-900 ring-offset-2' : 'hover:opacity-90'}`}
              title={crashRiskFilter === badge.label ? 'Click to clear filter' : `Filter tickers by ${badge.label}`}
            >
              {badge.text}
            </button>
          ))}
        </div>
      </div>

      <div className="dashboard-card p-4">
        <div className="flex items-center gap-3">
          <div className="relative flex-1 max-w-md">
            <Input
              type="text"
              placeholder="Search tickers (e.g., BTC, GOLD, TSLA)..."
              value={searchQuery}
              onChange={(event) => setSearchQuery(event.target.value)}
              className="pl-10"
            />
            <Target className="w-4 h-4 text-slate-400 absolute left-3 top-1/2 -translate-y-1/2" />
          </div>

          <span className="text-sm text-slate-500">
            {filteredSymbolsCount} of {totalSymbolsCount} tickers
          </span>

          {(searchQuery || categoryFilter !== 'All' || crashRiskFilter !== 'All') && (
            <Button
              variant="ghost"
              size="sm"
              onClick={() => {
                setSearchQuery("");
                setCategoryFilter("All");
                setCrashRiskFilter("All");
              }}
              className="text-slate-400 hover:text-slate-600"
            >
              <X className="w-4 h-4" />
            </Button>
          )}
        </div>

        <div className="flex flex-wrap gap-2 mt-3">
          {['All', 'Stocks', 'Cryptocurrency', 'Precious Metals'].map((category) => (
            <button
              key={category}
              onClick={() => setCategoryFilter(category)}
              className={`px-3 py-1.5 rounded-lg text-sm font-medium transition-colors border ${
                categoryFilter === category
                  ? 'bg-slate-900 text-white border-slate-900'
                  : 'bg-white text-slate-600 border-slate-200 hover:bg-slate-50'
              }`}
            >
              {category}
            </button>
          ))}
        </div>
      </div>
    </>
  );
}